import { render, staticRenderFns } from "./AuditoriaInventario.vue?vue&type=template&id=08985027&scoped=true"
import script from "./AuditoriaInventario.vue?vue&type=script&lang=js"
export * from "./AuditoriaInventario.vue?vue&type=script&lang=js"
import style0 from "./AuditoriaInventario.vue?vue&type=style&index=0&id=08985027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08985027",
  null
  
)

export default component.exports